import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useLabourData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();
  const { data: labourData, isPending } = useQuery({
    queryKey: [QueryKey.LabourSection, datasetId, id],
    queryFn: () =>
      Plants.getLabour({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }).then(response => {
        return response;
      }),
    throwOnError: true,
    enabled: shouldFetchData,
  });

  return { labourData, isPending };
};
